import PageLayout from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

const InvalidDevicePage = () => {
  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.INVALID_DEVICE_ERROR}}
      className="container-bridge"
      articleClassName="content-full"
    >
      <div className="inner_g">
        <div className="group_empty type2">
          <strong className="tit_g">
            <span className="item_txt" role="text">
              <span className="txt_tit">
                주 사용 기기에 있는 <br />
                카카오톡으로 이용해 주세요
              </span>
            </span>
          </strong>
          <p className="txt_g">
            디지털카드 서비스는 주 사용 기기에만 <br />
            이용 가능합니다. (휴대폰, 태블릿, PC 등)
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default InvalidDevicePage;
